import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2352c52f"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "taskListTableContainer" }
const _hoisted_2 = { class: "taskTitle" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "任务列表", -1))
const _hoisted_4 = { class: "example-pagination-block" }

import { ref, computed, onMounted, onUnmounted } from 'vue';
import { TaskGetters, TaskActions, TaskMutations } from '@/store/modules/task';
import GenTask from '@/components/task/genTask.vue'
import { useRoute } from 'vue-router';
import { useStore } from 'vuex';
import {
    Task,
    TaskStatusEnum,
    TaskTypeEnum,
    TaskType,
    TaskStatusFilter,
    TaskTypesFilter,
    OptionConstruction,
    crontabIntervalType,
    crontabDailyType,
    crontabOnceType,
} from "@/store/modules/task/types";
import { ArrowDown } from '@element-plus/icons-vue'
import { ElMessage } from 'element-plus'


import { defineComponent } from 'vue';
import { taskAPI } from '@/api/task';

const __default__ = defineComponent({
    name: "TaskListTable",
});


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const crontabType = ref<number>()
const crontabTime = ref<string>()
const intervalTime = ref<number>(2)
const crontabOptionList: OptionConstruction[] = [
    {
        label: "周期任务（需选择每次任务执行的时间间隔）",
        value: crontabIntervalType,
    }, {
        label: "单次定时任务（需选择本次任务执行的时间点）",
        value: crontabOnceType,
    }, {
        label: "每日定时任务（需选择每日任务执行的时间点）",
        value: crontabDailyType,
    },
]
const store = useStore();
const route = useRoute();

const projectId = computed(
    () => typeof (route.params.projId) === "string" ? route.params.projId : route.params.projId[0]
);
const targetId = computed(
    () => typeof (route.params.targetId) === "string" ? route.params.targetId : route.params.targetId[0]
);
const createTargetVisible = ref<boolean>(false)
const crontabDialogVisiable = ref<boolean>(false)
const pageSize = ref<number>(10)
const currentPage = ref<number>(1)
const total = ref<number>(0)
const selectedTask = ref<Task>()
const TaskListByUid = computed(() => {
    return store.getters[`task/${TaskGetters.getTaskListByUid}`];
});
const IsTaskByUidLoading = computed(() => {
    return store.getters[`task/${TaskGetters.getTaskByUidLoading}`];
});
const disabledTime = (time: Date): boolean => {
    return time.getTime() < Date.now() + 5 * 60 * 1000;
}

const createTask = async () => {
    createTargetVisible.value = true
}

const handleRefresh = async () => {
    store.commit(`task/${TaskMutations.resetAll}`);
    await asyncGetTaskList()
}

const asyncGetTaskList = async () => {
    if (TaskListByUid.value.length === 0) {
        const projId = projectId.value
        const uid = targetId.value
        const typeList = JSON.stringify(
            [
                TaskTypeEnum.TgMsgCode,
                TaskTypeEnum.WeChatMsgCode,
                TaskTypeEnum.SkypeMsgCode,
                TaskTypeEnum.FileConstructionCode,
                TaskTypeEnum.BrowserCode,
            ]
        )
        const pageNum = currentPage.value
        await store.dispatch(
            `task/${TaskActions.asyncGetTaskListByProjIdAndUidAndTypes}`,
            { projId, uid, typeList, pageNum },
        );
        total.value = TaskListByUid.value.length
    }
};
const sizeChange = (val: number) => {
    pageSize.value = val
}
const getType = (data: Task): string => {
    let taskType = TaskType.get(data.type)
    if (typeof taskType === "string") {
        return taskType
    } else {
        return "unknown"
    }
}

const getDisplayTime = (data: string) => {
    const date = (new Date(new Date(new Date(data).toUTCString()).getTime() + 8 * 60 * 60 * 1000)).toISOString()
    return date.substring(0, 10) + "  " + date.substring(11, 19)
}

const handleRowClick = async (row: Task) => {
    if (getPayload(row) === "" && getPayloadRes(row) === "") {
        const projId = projectId.value
        const uid = targetId.value
        const taskId = row.id

        await store.dispatch(`task/${TaskActions.asyncGetPayloadByTaskId}`, { projId, uid, taskId })
    }
}

const getPayload = (row: Task): string => {
    return store.getters[`task/${TaskGetters.getPayloadByTaskId}`](row.id);
}
const getPayloadRes = (row: Task): string => {
    return store.getters[`task/${TaskGetters.getPayloadResByTaskId}`](row.id);
}
const getPayloadLoading = (row: Task): boolean => {
    return store.getters[`task/${TaskGetters.getIsLoadingByTaskId}`](row.id);
}

const filterForChange = (value: string, row: any, column: any) => {
    return row[column['property']] === value;
}

const handleCommand = async (data: string | number | object) => {
    const { command, task } = data
    selectedTask.value = task
    const projId = projectId.value
    const uid = targetId.value
    const taskId = selectedTask.value?.id
    if (command === "crontab") {
        let isExist: boolean = false
        try {
            isExist = await taskAPI.CheckIsCrontabExistByTaskId(projId, uid, taskId)
        } catch (err) {
            return
        }
        if (!isExist) {
            crontabDialogVisiable.value = true
        } else {
            ElMessage({
                message: '每个taskId只能有一个定时任务，此ID已有定时任务存在',
                type: 'error',
            })
        }
    }
}
const TimeFormat = (type: number, timeOrigin: string): string => {
    if (type === crontabOnceType) {
        return new Date(timeOrigin).toISOString()
    } else if (type === crontabDailyType) {
        var currentDate = new Date();
        var [hours, minutes] = timeOrigin.split(":").map(Number);
        currentDate.setHours(hours, minutes, 0, 0);
        return currentDate.toISOString()
    }
    return "0001-01-01T00:00:00Z"
}

const updateOnSubmit = async () => {
    const projId = projectId.value
    const uid = targetId.value
    const taskId = selectedTask.value?.id
    await taskAPI.CreateCrontabTask({ "projId": projId, "uid": uid, "taskId": taskId, "crontabType": crontabType.value, "crontabTime": TimeFormat(crontabType.value!, crontabTime.value!), "intervalTime": intervalTime.value })
    ElMessage({
        message: '修改成功',
        type: 'success',
    })
    crontabDialogVisiable.value = false
    crontabType.value = undefined
    crontabTime.value = ""
    intervalTime.value = 0

}

onMounted(async () => {
    await asyncGetTaskList()
})

onUnmounted(() => {
    store.commit(`task/${TaskMutations.resetAll}`);
})



return (_ctx: any,_cache: any) => {
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_descriptions_item = _resolveComponent("el-descriptions-item")!
  const _component_el_descriptions = _resolveComponent("el-descriptions")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_dropdown_item = _resolveComponent("el-dropdown-item")!
  const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu")!
  const _component_el_dropdown = _resolveComponent("el-dropdown")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_empty = _resolveComponent("el-empty")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_input_number = _resolveComponent("el-input-number")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_time_picker = _resolveComponent("el-time-picker")!
  const _component_el_form = _resolveComponent("el-form")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_el_dialog, {
        modelValue: createTargetVisible.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((createTargetVisible).value = $event)),
        title: "新建任务",
        width: "50%"
      }, {
        default: _withCtx(() => [
          _createVNode(GenTask, {
            projId: _unref(projectId),
            uid: _unref(targetId)
          }, null, 8, ["projId", "uid"])
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_el_button, {
          type: "primary",
          style: {"float":"right","margin-right":"50px"},
          onClick: createTask
        }, {
          default: _withCtx(() => [
            _createTextVNode("新建")
          ]),
          _: 1
        }),
        _createVNode(_component_el_button, {
          type: "primary",
          style: {"float":"right","margin-right":"10px"},
          onClick: handleRefresh
        }, {
          default: _withCtx(() => [
            _createTextVNode("刷新")
          ]),
          _: 1
        }),
        _hoisted_3
      ]),
      (_unref(TaskListByUid)[0] !== null)
        ? _withDirectives((_openBlock(), _createBlock(_component_el_table, {
            key: 0,
            data: _unref(TaskListByUid).slice((currentPage.value - 1) * pageSize.value, currentPage.value * pageSize.value),
            stripe: "",
            onExpandChange: handleRowClick
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_table_column, { type: "expand" }, {
                default: _withCtx((props) => [
                  _withDirectives((_openBlock(), _createElementBlock("div", null, [
                    _createVNode(_component_el_descriptions, {
                      class: "payloadDescription",
                      direction: "horizontal",
                      column: 1,
                      border: ""
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_descriptions_item, {
                          "label-class-name": "descriptionLableClass",
                          label: "Payload",
                          align: "center"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(getPayload(props.row)), 1)
                          ]),
                          _: 2
                        }, 1024),
                        _createVNode(_component_el_descriptions_item, {
                          "label-class-name": "descriptionLableClass",
                          label: "ResPayload",
                          align: "center"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(getPayloadRes(props.row)), 1)
                          ]),
                          _: 2
                        }, 1024)
                      ]),
                      _: 2
                    }, 1024)
                  ])), [
                    [_directive_loading, getPayloadLoading(props.row)]
                  ])
                ]),
                _: 1
              }),
              _createVNode(_component_el_table_column, {
                align: "center",
                prop: "id",
                label: "ID"
              }),
              _createVNode(_component_el_table_column, {
                align: "center",
                prop: "status",
                label: "状态",
                filters: _unref(TaskStatusFilter),
                "filter-method": filterForChange,
                "filter-multiple": false
              }, {
                default: _withCtx((scope) => [
                  (scope.row.status === _unref(TaskStatusEnum).StatusIdle)
                    ? (_openBlock(), _createBlock(_component_el_tag, {
                        key: 0,
                        type: "info"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("未知")
                        ]),
                        _: 1
                      }))
                    : (scope.row.status === _unref(TaskStatusEnum).StatusProcessing)
                      ? (_openBlock(), _createBlock(_component_el_tag, { key: 1 }, {
                          default: _withCtx(() => [
                            _createTextVNode("处理中")
                          ]),
                          _: 1
                        }))
                      : (scope.row.status === _unref(TaskStatusEnum).StatusDownloading)
                        ? (_openBlock(), _createBlock(_component_el_tag, { key: 2 }, {
                            default: _withCtx(() => [
                              _createTextVNode("获取中")
                            ]),
                            _: 1
                          }))
                        : (scope.row.status === _unref(TaskStatusEnum).StatusFinished)
                          ? (_openBlock(), _createBlock(_component_el_tag, {
                              key: 3,
                              type: "success"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode("成功")
                              ]),
                              _: 1
                            }))
                          : (scope.row.status === _unref(TaskStatusEnum).StatusFailed)
                            ? (_openBlock(), _createBlock(_component_el_tag, {
                                key: 4,
                                type: "danger"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode("错误")
                                ]),
                                _: 1
                              }))
                            : (scope.row.status === _unref(TaskStatusEnum).StatusPending)
                              ? (_openBlock(), _createBlock(_component_el_tag, {
                                  key: 5,
                                  type: "info"
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode("等待")
                                  ]),
                                  _: 1
                                }))
                              : _createCommentVNode("", true)
                ]),
                _: 1
              }, 8, ["filters"]),
              _createVNode(_component_el_table_column, {
                align: "center",
                prop: "type",
                label: "类型",
                filters: _unref(TaskTypesFilter),
                "filter-method": filterForChange,
                "filter-multiple": false
              }, {
                default: _withCtx((scope) => [
                  _createTextVNode(_toDisplayString(getType(scope.row)), 1)
                ]),
                _: 1
              }, 8, ["filters"]),
              _createVNode(_component_el_table_column, {
                align: "center",
                prop: "createAt",
                label: "创建时间"
              }, {
                default: _withCtx((scope) => [
                  _createTextVNode(_toDisplayString(getDisplayTime(scope.row.createAt)), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_el_table_column, {
                align: "center",
                prop: "updateAt",
                label: "更新时间"
              }, {
                default: _withCtx((scope) => [
                  _createTextVNode(_toDisplayString(getDisplayTime(scope.row.updateAt)), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_el_table_column, { label: "操作" }, {
                default: _withCtx((scope) => [
                  _createVNode(_component_el_dropdown, { onCommand: handleCommand }, {
                    dropdown: _withCtx(() => [
                      _createVNode(_component_el_dropdown_menu, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_dropdown_item, {
                            disabled: !((scope.row.type === _unref(TaskTypeEnum).TgMsgCode || scope.row.type === _unref(TaskTypeEnum).SkypeMsgCode) && scope.row.status === _unref(TaskStatusEnum).StatusFinished),
                            command: { command: 'crontab', task: scope.row }
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("设为定时任务")
                            ]),
                            _: 2
                          }, 1032, ["disabled", "command"]),
                          _createVNode(_component_el_dropdown_item, {
                            disabled: scope.row.status !== _unref(TaskStatusEnum).StatusFailed,
                            command: { command: 'restart', task: scope.row }
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("重启")
                            ]),
                            _: 2
                          }, 1032, ["disabled", "command"])
                        ]),
                        _: 2
                      }, 1024)
                    ]),
                    default: _withCtx(() => [
                      _createVNode(_component_el_button, { type: "primary" }, {
                        default: _withCtx(() => [
                          _createTextVNode(" 操作"),
                          _createVNode(_component_el_icon, { class: "el-icon--right" }, {
                            default: _withCtx(() => [
                              _createVNode(_unref(ArrowDown))
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 2
                  }, 1024)
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["data"])), [
            [_directive_loading, _unref(IsTaskByUidLoading)]
          ])
        : (_openBlock(), _createBlock(_component_el_empty, {
            key: 1,
            "image-size": 200
          }))
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_el_pagination, {
        "current-page": currentPage.value,
        "onUpdate:currentPage": _cache[1] || (_cache[1] = ($event: any) => ((currentPage).value = $event)),
        background: true,
        layout: " prev, pager, next",
        "page-sizes": [5, 10, 20],
        "default-page-size": 10,
        total: total.value,
        onSizeChange: sizeChange
      }, null, 8, ["current-page", "total"])
    ]),
    _createVNode(_component_el_dialog, {
      modelValue: crontabDialogVisiable.value,
      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((crontabDialogVisiable).value = $event)),
      title: "设为定时任务"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_form, { "label-width": "150px" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, { label: "任务Id" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(selectedTask.value.id), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { label: "任务类型" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(getType(selectedTask.value)), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { label: "定时任务类型" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  modelValue: crontabType.value,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((crontabType).value = $event)),
                  placeholder: "请选择",
                  width: "200"
                }, {
                  default: _withCtx(() => [
                    (_openBlock(), _createElementBlock(_Fragment, null, _renderList(crontabOptionList, (option) => {
                      return _createVNode(_component_el_option, {
                        key: option.value,
                        value: option.value,
                        label: option.label
                      }, null, 8, ["value", "label"])
                    }), 64))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }),
            (crontabType.value === _unref(crontabIntervalType))
              ? (_openBlock(), _createBlock(_component_el_form_item, {
                  key: 0,
                  label: "选择任务间隔时间"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input_number, {
                      modelValue: intervalTime.value,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((intervalTime).value = $event)),
                      min: 2,
                      size: "small"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }))
              : (crontabType.value === _unref(crontabOnceType))
                ? (_openBlock(), _createBlock(_component_el_form_item, {
                    key: 1,
                    label: "选择执行时间"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_date_picker, {
                        modelValue: crontabTime.value,
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((crontabTime).value = $event)),
                        type: "datetime",
                        "value-format": "YYYY-MM-DD HH:mm",
                        format: "YYYY-MM-DD HH:mm",
                        placeholder: "请选择任务执行时间",
                        "disabled-date": disabledTime
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }))
                : (crontabType.value === _unref(crontabDailyType))
                  ? (_openBlock(), _createBlock(_component_el_form_item, {
                      key: 2,
                      label: "选择每日执行时间"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_time_picker, {
                          modelValue: crontabTime.value,
                          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((crontabTime).value = $event)),
                          placeholder: "请选择每日执行时间",
                          "value-format": "HH:mm",
                          format: "HH:mm"
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
            _createVNode(_component_el_form_item, null, {
              default: _withCtx(() => [
                _createVNode(_component_el_button, {
                  type: "primary",
                  onClick: updateOnSubmit
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("提交")
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_button, {
                  type: "primary",
                  onClick: _cache[6] || (_cache[6] = ($event: any) => (crontabDialogVisiable.value = false))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("取消")
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}
}

})